//avatarApi.ts — the avatar app's calls to its own Worker

import type { AvatarCharacter } from '../../shared/avatarCharacter'
import { request } from '../api/client'

export const fetchAvatarCharacters = (): Promise<AvatarCharacter[]> =>
	request<AvatarCharacter[]>('/api/characters')

export const saveAvatarCharacters = (
	characters: readonly AvatarCharacter[],
): Promise<{ characters: AvatarCharacter[] }> =>
	request<{ characters: AvatarCharacter[] }>('/api/admin/characters', {
		method: 'PUT',
		headers: { 'content-type': 'application/json' },
		body: JSON.stringify(characters),
	})

//A fresh id per upload, so a cached image URL never shows stale bytes.
export async function uploadAvatarImage(file: File): Promise<string> {
	const id = crypto.randomUUID()
	await request(`/api/admin/image?id=${id}`, {
		method: 'POST',
		headers: { 'content-type': file.type },
		body: file,
	})
	return id
}
